export default "__VITE_ASSET__Du83eAKC__"